module.exports = __webpack_public_path__ + "img/features6.565eb9de.png";